import { classes } from 'html-classes';

import styles from './Spinner.module.scss';

export interface SpinnerProps {
  variant?: 'default' | 'white';
  size?: number;
  className?: string;
}

const Spinner = ({ variant = 'default', size, className }: SpinnerProps) => {
  return (
    <span
      className={classes([
        styles.spinner,
        variant === 'white' && styles.white,
        className,
      ])}
      style={size ? { width: size, height: size } : undefined}
    />
  );
};

export default Spinner;
